import { ISession } from '../../models/pro-sites';

export const hasFeature = (session: ISession, feature: string): boolean => {
    return session.features.some((r) => feature === r.featureName);
};

export const hasFeatures = (session: ISession, features: string[]): boolean => {
    return session.features.some((r) => features.includes(r.featureName));
};
